import { forwardRef, useCallback, useMemo, useState } from "react";
import { Autocomplete, TextField, MenuItem, Typography } from "@mui/material";
import { FixedSizeList as List } from "react-window";
import { debounce } from "lodash";

interface FilterInputProps {
    options: string[];
    onChange: (s: string, cs: boolean) => void;
    value: string;
    isCaseSensitive: boolean;
}

const ListboxComponent = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement>>(
    function ListboxComponent(props, ref) {
        const { children, ...other } = props as any;
        const itemCount = Array.isArray(children) ? children.length : 0;
        const itemSize = 36; // Height of each menu item

        return (
            <div ref={ref} {...other}>
                <List
                    height={Math.min(250, itemCount * itemSize)}
                    itemCount={itemCount}
                    itemSize={itemSize}
                    width="100%"
                >
                    {({ index, style }) => (
                        <div style={style}>{children[index]}</div>
                    )}
                </List>
            </div>
        );
    });


const FilterInput = ({ options, onChange, value, isCaseSensitive }: FilterInputProps) => {

    const [textInput, setTextInput] = useState("");



    const memoizedOptions = useMemo(() => options, [options]);
    return (
        <Autocomplete
            fullWidth
            inputMode="search"
            freeSolo
            value={value}
            onChange={(event, value) => { onChange(value || "", event.type === 'click' && value != null) }}

            inputValue={textInput}
            onInputChange={(_, value) => setTextInput(value || "")}
            isOptionEqualToValue={(option, value) =>
                isCaseSensitive
                    ? option === value
                    : option.toLowerCase() === value.toLowerCase()
            }

            renderInput={({ inputProps, ...params }) => (
                <TextField
                    {...params}
                    inputProps={{
                        ...inputProps,
                        style: { fontSize: "0.875rem" },
                    }}
                    fullWidth
                    InputLabelProps={{
                        children: null,
                    }}
                />
            )}
            renderOption={(props, option) => (
                <MenuItem {...props}>
                    <Typography variant="body2">{option}</Typography>
                </MenuItem>
            )}
            ListboxComponent={ListboxComponent}
            options={memoizedOptions}
            disableListWrap
            disableCloseOnSelect={false}
        />
    );
};

export default FilterInput;
